module.exports = __webpack_public_path__ + "img/BRCA1_B.3d3e2857.png";